/* Honey GiftArts theme JS. Config comes from window.HG (set in layout/theme.liquid). */
(function () {
  var HG = window.HG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'hg-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2400);
  }
  function money(cents) {
    var f = HG.money || 'Rs. {{amount}}', v = (cents / 100).toFixed(2);
    function fmt(n, d, t, p) {
      n = (n / 100).toFixed(d || 2).split('.');
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (t || ',')) + (n[1] ? (p || '.') + n[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount') return fmt(cents, 2);
      if (k === 'amount_no_decimals') return fmt(cents, 0);
      if (k === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.');
      return v;
    });
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }

  /* header: mobile menu + search */
  var navBtn = $('[data-nav-toggle]'), nav = $('#hg-nav');
  if (navBtn && nav) navBtn.addEventListener('click', function () {
    var o = nav.classList.toggle('is-open'); navBtn.setAttribute('aria-expanded', o);
  });
  var sBtn = $('[data-search-toggle]'), sBar = $('[data-searchbar]');
  if (sBtn && sBar) sBtn.addEventListener('click', function () {
    sBar.hidden = !sBar.hidden; if (!sBar.hidden) { var i = $('input', sBar); if (i) i.focus(); }
  });

  /* collection: sort */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });

  /* product page */
  $$('[data-product-section]').forEach(function (sec) {
    var form = $('[data-product-form]', sec); if (!form) return;
    var vJson = $('[data-variants]', sec), variants = vJson ? JSON.parse(vJson.textContent) : [];
    var idInput = $('[data-variant-id]', form), qty = $('[data-qty-input]', form);
    var slides = $$('[data-slide]', sec), thumbs = $$('[data-thumb]', sec), cur = 0;

    function show(i) {
      if (!slides.length) return; cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var pv = $('[data-prev]', sec), nx = $('[data-next]', sec);
    if (pv) pv.addEventListener('click', function () { show(cur - 1); });
    if (nx) nx.addEventListener('click', function () { show(cur + 1); });

    /* lightbox zoom */
    var lb = null;
    function openLb() {
      var s = slides[cur]; if (!s) return;
      if (!lb) {
        lb = document.createElement('div'); lb.className = 'hg-lb'; lb.hidden = true;
        lb.innerHTML = '<button type="button" aria-label="Close">&times;</button><div class="hg-lb__img"></div>';
        document.body.appendChild(lb);
        lb.addEventListener('click', function (e) {
          var box = $('.hg-lb__img', lb);
          if (e.target === lb || e.target.tagName === 'BUTTON') { lb.hidden = true; lb.classList.remove('is-zoom'); return; }
          lb.classList.toggle('is-zoom');
          var r = box.getBoundingClientRect();
          box.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && !lb.hidden) { lb.hidden = true; lb.classList.remove('is-zoom'); } });
      }
      $('.hg-lb__img', lb).innerHTML = '<img src="' + s.getAttribute('data-zoom') + '" alt="">';
      lb.classList.remove('is-zoom'); lb.hidden = false;
    }
    var st = $('[data-stage]', sec), zb = $('[data-zoom-btn]', sec);
    if (st) st.addEventListener('click', openLb);
    if (zb) zb.addEventListener('click', openLb);

    /* variants */
    function selected() {
      return $$('[data-option]', sec).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant() {
      var sel = selected(); if (!sel.length) return variants[0];
      return variants.filter(function (v) { return sel.every(function (x, i) { return v.options[i] === x; }); })[0];
    }
    function updateWa(v) {
      var a = $('[data-wa]', sec); if (!a) return;
      var t = $('[data-prop-text]', form), msg = 'Hi Honey GiftArts, I want to order: ' + (HG.productTitle || '') +
        (v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' x' + (qty ? qty.value : 1) +
        (t && t.value ? '\nText: ' + t.value : '') + '\n' + location.href.split('?')[0];
      a.href = 'https://wa.me/' + HG.wa + '?text=' + encodeURIComponent(msg);
    }
    function onVariant() {
      var v = findVariant(), buy = $('[data-buy-now]', sec), add = $('[data-add]', sec);
      if (idInput && v) idInput.value = v.id;
      if (v) {
        var p = $('[data-price]', sec), c = $('[data-compare]', sec);
        if (p) p.textContent = money(v.price);
        if (c) { c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; c.hidden = !(v.compare_at_price > v.price); }
        [buy, add].forEach(function (b) { if (b) b.disabled = !v.available; });
        if (buy) buy.textContent = v.available ? 'Buy Now' : 'Sold out';
        if (v.featured_media) { var k = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); }); if (k > -1) show(k); }
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      updateWa(v);
    }
    $$('[data-option] input', sec).forEach(function (i) { i.addEventListener('change', onVariant); });

    /* quantity */
    $$('[data-qty]', sec).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10)); updateWa(findVariant()); });
    });
    if (qty) qty.addEventListener('input', function () { updateWa(findVariant()); });

    /* custom text counters */
    $$('[data-prop-text]', form).forEach(function (i) {
      var c = i.parentNode.querySelector('[data-counter]');
      function u() { if (c) c.textContent = i.value.length + '/' + i.maxLength; updateWa(findVariant()); }
      i.addEventListener('input', u); u();
    });

    /* photo upload */
    $$('[data-photo-input]', form).forEach(function (inp) {
      var box = inp.closest('.hg-step').querySelector('[data-preview]'), label = inp.closest('.hg-drop');
      function change() {
        var f = inp.files[0]; box.hidden = true; box.innerHTML = ''; if (!f) return; box.hidden = false;
        if (f.type.indexOf('image/') !== 0 || f.size > 20 * 1024 * 1024) { inp.value = ''; box.textContent = 'Please choose an image under 20 MB.'; return; }
        var im = new Image(); im.alt = 'Selected photo'; im.src = URL.createObjectURL(f); box.appendChild(im);
        var s = document.createElement('span'); s.textContent = f.name; box.appendChild(s);
      }
      inp.addEventListener('change', change);
      ['dragenter', 'dragover'].forEach(function (ev) { label.addEventListener(ev, function (e) { e.preventDefault(); label.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { label.addEventListener(ev, function (e) { e.preventDefault(); label.classList.remove('is-drag'); }); });
      label.addEventListener('drop', function (e) {
        var f = e.dataTransfer.files[0]; if (!f) return;
        try { var d = new DataTransfer(); d.items.add(f); inp.files = d.files; change(); } catch (x) { toast('Please use the upload box to choose your photo'); }
      });
    });

    /* add to cart (ajax when no file is attached; normal form post otherwise) */
    var add = $('[data-add]', sec);
    if (add) add.addEventListener('click', function (e) {
      var hasFile = $$('input[type=file]', form).some(function (i) { return i.files && i.files.length; });
      if (hasFile) return;
      e.preventDefault();
      var fd = new FormData(form); $$('input[type=file]', form).forEach(function (i) { fd.delete(i.name); });
      fetch(HG.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { setCount(c.item_count); toast('Added to cart'); })
        .catch(function () { toast('Could not add to cart. Please try again.'); });
    });
    onVariant();

    /* tabs */
    var tabs = $$('[data-tab]', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t); });
        $$('[data-tabpanel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-tabpanel') !== t.getAttribute('data-tab'); });
      });
    });
  });

  /* recommendations */
  $$('[data-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (h) {
      var d = document.createElement('div'); d.innerHTML = h; var n = $('[data-recs]', d);
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML; else { var s = el.closest('section'); if (s) s.hidden = true; }
    }).catch(function () {});
  });

  /* cart page: update on quantity change */
  $$('[data-cart-form] input[name="updates[]"]').forEach(function (i) {
    i.addEventListener('change', function () { var b = $('[name=update]', i.form); if (b) b.click(); });
  });

  /* cookie banner (Shopify Customer Privacy API) */
  var cb = $('[data-cookie-text]');
  if (cb && HG.cookieBanner) {
    var k = 'hg_cookie_choice', done = null;
    try { done = localStorage.getItem(k); } catch (e) {}
    if (!done) {
      var b = document.createElement('div'); b.className = 'hg-ck'; b.setAttribute('role', 'dialog'); b.setAttribute('aria-label', 'Cookie consent');
      var p = document.createElement('p'); p.textContent = cb.getAttribute('data-cookie-text');
      var w = document.createElement('div');
      [['Allow', true, 'hg-btn'], ['Deny', false, 'hg-btn hg-btn--outline']].forEach(function (x) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = x[2]; btn.textContent = x[0];
        btn.addEventListener('click', function () {
          try { localStorage.setItem(k, x[1] ? 'allow' : 'deny'); } catch (e) {}
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
              if (!err && window.Shopify.customerPrivacy) window.Shopify.customerPrivacy.setTrackingConsent({ analytics: x[1], marketing: x[1], preferences: x[1], sale_of_data: x[1] }, function () {});
            });
          } catch (e) {}
          b.remove();
        });
        w.appendChild(btn);
      });
      b.appendChild(p); b.appendChild(w); document.body.appendChild(b);
    }
  }
})();
